import { deriveBaseHostname } from "./deriveBaseHostname.ts";

export function validateReturnTo(returnTo: string, allowedOrigins: string[]): string | null {
  try {
    const url = new URL(returnTo);
    if (allowedOrigins.includes(url.origin)) return returnTo;

    const baseHostname = deriveBaseHostname(allowedOrigins.map((o) => new URL(o).hostname));
    if (!baseHostname) return null;
    if (url.protocol !== "https:") return null;
    if (url.hostname === baseHostname) return returnTo;
    if (url.hostname.endsWith("." + baseHostname)) return returnTo;
    return null;
  } catch {
    return null;
  }
}
